import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { DataService } from 'src/app/dashboard/_services/data.service';

@Component({
  selector: 'app-switch-cs-btns',
  templateUrl: './switch-cs-btns.component.html',
  styleUrls: ['./switch-cs-btns.component.scss']
})
export class SwitchCsBtnsComponent {
  currentRoute: string;
  routerSubscription: Subscription;

  constructor(private router: Router, private dataService: DataService) { }

  ngOnInit() {
    // Capture the initial route
    this.currentRoute = this.router.url;
    // console.log('Initial route', this.currentRoute);

    // Subscribe to NavigationEnd events
    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentRoute = event.urlAfterRedirects;
      // console.log('url', event.urlAfterRedirects);
    });
  }

  isRouteActive(route: string): boolean {
    // console.log('current route', this.currentRoute);
    // console.log('route', route);
    return this.currentRoute === route;
  }


  navigateToDismissal_CS() {
    // Check if it's a beta school and navigate to the correct calling screen
    this.dataService.getIsCallingScreenBeta().subscribe(isBeta => {
      if (isBeta) {
        this.router.navigate(['/calling-screen/calling-screen-beta']);
      } else {
        this.router.navigate(['/calling-screen/calling-screen']);
      }
    });
  }

  navigateToBus_CS() {
    this.router.navigate(['/bus-calling-screen/bus-calling-screen']);
  }

  ngOnDestroy() {
    // Clean up the subscription to avoid memory leaks
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
